/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import React from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import parse from "html-react-parser";
import { useConfig } from "../config/configContext";
import { FlexStart } from "./Layout";

const InfoSection = styled.div`
  margin-right: 3rem;
  max-width: 18.5rem;
  padding-bottom: 1rem;
`;

const Info = styled(FlexStart)`
  color: white;
  align-items: flex-start;

  ${(props) => props.theme.breakpoints.down("sm")} {
    flex-direction: column;
  }
`;

const InfoHeading = styled(Typography)`
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  margin-bottom: 0.65rem;
  text-shadow: 1px 1px ${(props) => props.theme.palette.text.primary}; ;
`;

const InfoText = styled.div`
  font-size: 1rem;
  margin-bottom: 1.2rem;
  text-shadow: 1px 1px ${(props) => props.theme.palette.text.primary};

  li {
    margin-bottom: 1rem;
  }

  a {
    color: white;
  }
`;

export const AboutSection = () => {
  const { content } = useConfig();
  const { about, disclaimer, contact } = content;

  return (
    <Info>
      <InfoSection>
        <InfoHeading variant="h5">{about.heading}</InfoHeading>
        <InfoText>{parse(about.text)}</InfoText>
      </InfoSection>
      <InfoSection>
        <InfoHeading variant="h5">{disclaimer.heading}</InfoHeading>
        <InfoText>{parse(disclaimer.text)}</InfoText>
      </InfoSection>
      <InfoSection>
        <InfoHeading variant="h5">{contact.heading}</InfoHeading>
        <InfoText>{parse(contact.text)}</InfoText>
        <InfoText>{contact.phone}</InfoText>
        <InfoText>{parse(contact.website)}</InfoText>
      </InfoSection>
    </Info>
  );
};
